import { TemplateRef } from "@angular/core";
import { normalizeStat } from "@nx-superprep/utils";

export enum PerformanceStat1NameEnum {
  correct = 'correct',
  studied = 'studied',
  retention = 'retention',
}
export enum PerformanceStat2NameEnum {
  streak = 'streak',
  completed = 'completed',
}
export enum PerformanceStat3NameEnum {
  today = 'today',
  overall = 'overall',
}
export enum PerformanceStatNameEnum {
  correct = PerformanceStat1NameEnum.correct,
  studied = PerformanceStat1NameEnum.studied,
  retention = PerformanceStat1NameEnum.retention,
  streak = PerformanceStat2NameEnum.streak,
  completed = PerformanceStat2NameEnum.completed,
  today = PerformanceStat3NameEnum.today,
  overall = PerformanceStat3NameEnum.overall,
 }
export type PerformanceSta1tName = `${PerformanceStat1NameEnum}`
export type PerformanceStat2Name = `${PerformanceStat2NameEnum}`
export type PerformanceStat3Name = `${PerformanceStat3NameEnum}`
export type PerformanceStatName = `${PerformanceStatNameEnum}`

export type PerformanceStatRecord = {range: PerformanceStat3Name, stats:PerformanceStats[]}

export interface StatEntry {
  readonly name: PerformanceStatName;
  readonly color: string;
  readonly background: string;
  readonly value: string;
  readonly count: number | string | undefined;
}

export interface PerformanceStats {
  name: PerformanceStatName
  value: number | string
  count?: number | string
  template?: TemplateRef<unknown>
  color?: string
  background?: string
}

export const _baseStats: Readonly<PerformanceStats>[] = [
  {name: 'streak', value:100, color:'black', background:'rgba(0, 106, 99, 0.04)'},
  {name: 'retention', value:100, color:'black', background:'rgba(49, 175, 212, 0.04)'},
  {name: 'correct', value:25000, count:25000, color:'black', background:'rgba(94, 43, 255, 0.04)'},
  {name: 'completed', value:100, color:'black', background:'rgba(242, 100, 25, 0.04)'},
  {name: 'studied', value:1000000, color:'black', background:'rgba(0, 106, 99, 0.04)'},
]

export const randomizeStat = ():PerformanceStats[] => {
  return _baseStats.map(s => {
    const t = {...s}
    t.value = normalizeStat((Number(s.value)||0) * Math.random(), s.name === 'studied' ? 'duration' : 'number')
    t.count = t.count ? normalizeStat(1+(Number(s.count)||0) * Math.random(), 'number') : undefined
    return t
  }).slice()
}

export const _defaultStats = (fill = false): PerformanceStatRecord[] => (
  fill
    ? [PerformanceStat3NameEnum.today, PerformanceStat3NameEnum.overall]
      .map(range => ({
        range,
        stats: randomizeStat().filter((s) => s.name !== 'streak').map((s) => {s.value = 0; return s}),
      }))
    : []
);

export const isSamePerformanceStatRecord = (a:PerformanceStatRecord, b:PerformanceStatRecord): boolean => {
  return (
    a === b || (
      a.range === b.range &&
      a.stats.every((stat) =>
        !!b.stats.find((s) => s.name === stat.name && s.value === stat.value)
      )
    )
  )
}

export const isSamePerformanceStatRecordArray = (a:PerformanceStatRecord[], b:PerformanceStatRecord[]): boolean => {
  return (
    a === b || (
      a.length === b.length &&
      a.every((record) =>
        !!b.find(
          (r) =>
            r.range === record.range && isSamePerformanceStatRecord(r, record)
        )
      )
    )
  )
}
